export const ROOT: string = '/';
export const MAP: string = '/karte';
export const SEARCH: string = '/meklet';
export const ADD: string = '/pievienot';
